




























































import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { MatchNoneCDCLikelyAndGSRPContent } from "@/models/content/match-none-cdc-likely-and-gsrp";
import { AppData } from "@/models/app-data";
import CommonMixin, {
  WORKFLOW_PREFERRED_GREAT_START,
} from "@/mixins/common-mixins";
import PageLoader from "@/components/PageLoader.vue"

@Component({
  components: {PageLoader},
})
export default class MatchNoneCDCLikelyAndGSRP extends Mixins(CommonMixin) {
  content: MatchNoneCDCLikelyAndGSRPContent = {} as MatchNoneCDCLikelyAndGSRPContent;
  appData = {} as AppData;
  loadDataFinished = false;
  textDirection = "ltr";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchNoneCDCLikelyAndGSRPContent();
      this.textDirection = contentService.TextDirection();    

      this.appData = this.getAppData();
      if ( this.appData != null){
        this.appData.preferredProgram = WORKFLOW_PREFERRED_GREAT_START;
        this.saveAppData(this.appData);
        await this.putWorkflowStep( this.appData.workflowId, "MatchNoneCDCLikelyAndGSRP") 
        await this.postWorkflowEligible(
          this.appData.workflowId,
          this.appData.preferredProgram
        );
      }
      this.loadDataFinished = true;
    } catch (error) {
      this.showError(error);
    }
  }

  public async handleApply4YearOlds(): Promise<void> {
    this.appData.numberOfChildrenApplying = this.appData.number4YearOlds;
    this.appData.applyGreatStart = true;
    this.saveAppData(this.appData);
    this.$router.push({ path: "StartApplication" });
  }

  public async handleApplyAll(): Promise<void> {
    this.appData.numberOfChildrenApplying = this.appData.numberChildren;
    this.appData.applyGreatStart = true;
    this.saveAppData(this.appData);
    this.$router.push({ path: "StartApplication" });
  }

  public async handleLearnMore(): Promise<void> {
    window.open( this.content.LearnMoreLink, "_blank"); 
    await this.publishWebCDCClickEvent( this.appData.workflowId) 
  }

  disableNext(): boolean {
    return !this.loadDataFinished;
  }
}
